/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; // Importez FormsModule ou ReactiveFormsModule
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import {
  // NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
// import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import player from 'lottie-web';
import { LottieModule } from 'ngx-lottie';
import { AuthModule } from './E-justice/authentification/auth.module';
import { HttpInterceptorProvider } from './E-justice/core/interceptors';
import { PublicRoutingModule } from './E-justice/Dashboards/PUBLIC/public-routing.module';
import { AddDossierComponent } from "./E-justice/dialogs/add-dossier/add-dossier.component";
import { ViewDetailRendezvousComponent } from "./E-justice/dialogs/view-detail-rendezvous/view-detail-rendezvous.component";
import { ViewDetailsFichesComponent } from "./E-justice/dialogs/view-details-fiches/view-details-fiches.component";
import { ViewListJuridictionsComponent } from "./E-justice/dialogs/view-list-juridictions/view-list-juridictions.component";
import { ViewListSignataireModule } from './E-justice/dialogs/view-list-signataire/view-list-signataire.module';



// import { LoginSigninComponent } from './authentification/login-signin/login-signin.component';

export function playerFactory() {
  return player;
}
export function createTranslateLoader(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

@NgModule({
  // providers: [BsModalService],

  declarations: [AppComponent,
    ViewDetailsFichesComponent,
    // LoginSigninComponent,
    ViewDetailRendezvousComponent,
    ViewListJuridictionsComponent,
    AddDossierComponent,
  ],
  imports: [
    TranslateModule.forRoot(
      {
        loader: {
          provide: TranslateLoader,
          useFactory: (createTranslateLoader),
          deps: [HttpClient]
        }
      }
    ),
    FormsModule,
    PublicRoutingModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    AuthModule,



    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    LottieModule.forRoot({ player: playerFactory }),
    ViewListSignataireModule,

      // NbChatModule.forRoot({
    //   messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    // }),
    // NbAuthModule.forRoot({
    //   forms: {
    //     login: {
    //       strategy: 'password',
    //       redirectDelay: 1000,
    //       // socialLinks: [
    //       //   {
    //       //     url: 'https://github.com/akveo',
    //       //     target: '_blank',
    //       //     title: 'GitHub',
    //       //   },
    //       //   {
    //       //     url: 'https://www.facebook.com/akveo',
    //       //     target: '_blank',
    //       //     icon: 'nb-home',
    //       //   },
    //       //   {
    //       //     url: 'https://www.facebook.com/akveo',
    //       //     target: '_blank',
    //       //     title: 'Twitter',
    //       //   },
    //       // ],
    //     },
    //   },
    //   strategies: [
    //     NbDummyAuthStrategy.setup({
    //       name: 'dummy',

    //       alwaysFail: true,
    //       delay: 1000,
    //     }),

    //     NbPasswordAuthStrategy.setup({
    //       name: 'email',
    //       // token: {
    //       //   class: NbAuthJWTToken,
    //       // },
    //       login: {
    //         requireValidToken: false,
    //       },
    //       baseEndpoint: '',
    //       logout: {
    //         redirect: {
    //           success: '/auth/login',
    //           failure: '/auth/login',
    //         },
    //       },
    //       requestPass: {
    //         redirect: {
    //           success: '/auth/reset-password',
    //         },
    //       },
    //       resetPass: {
    //         redirect: {
    //           success: '/auth/login',
    //         },
    //       },
    //       errors: {
    //         key: 'data.errors',
    //       },
    //     }),
    //     NbOAuth2AuthStrategy.setup({
    //       name: 'password',
    //       clientId: 'test',
    //       clientSecret: 'secret',
    //       baseEndpoint: '',
    //       // token: {
    //       //   endpoint: 'token',
    //       //   grantType: NbOAuth2GrantType.PASSWORD,
    //       //   class: NbAuthOAuth2Token,
    //       // },
    //       // refresh: {
    //       //   endpoint: 'refresh-token',
    //       //   grantType: NbOAuth2GrantType.REFRESH_TOKEN,
    //       // },
    //     }),
    //   ],
    // }),
    // NbAuthModule.forRoot({
    //   forms: {
    //     login: {
    //       redirectDelay: 3000,
    //       showMessages : {
    //         error: true,
    //         success: true,
    //       },
    //       strategy: 'password',
    //     },
    //   },
    //   strategies: [
    //      NbOAuth2AuthStrategy.setup({
    //       name: 'password',
    //       clientId: 'Aladdin',
    //       clientSecret: 'open sesame',
    //       clientAuthMethod: NbOAuth2ClientAuthMethod.BASIC,
    //       // baseEndpoint: 'http://localhost:4200/auth/',
    //       // token: {
    //       //   endpoint: 'token',
    //       //   grantType: NbOAuth2GrantType.PASSWORD,
    //       //   class: NbAuthOAuth2JWTToken,
    //       //   requireValidToken: true,
    //       // },
    //       redirect: {
    //         success: '/oauth2-password',
    //       },
    //     }),
    //   ],
    // }),

    // ModalModule
  ],
  schemas: [

    NO_ERRORS_SCHEMA
  ],
  providers: [
    HttpInterceptorProvider
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
